import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { ToastContainer, toast } from 'react-toastify';
import add from '../../assest/images/add.png';
import Icon5 from '../../assest/images/Icon5.png';
import Select from 'react-select'; // Assuming react-select is used
import { Modal } from 'react-bootstrap';
import { UserContext } from '../common/UserContext';
import config from "../../envconfig";
import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';

function ShipmentReturn() {
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [returnReason, setReturnReason] = useState('');
  const [shipmentDate, setShipmentDate] = useState(new Date());
  const [logisticParty, setLogisticParty] = useState([]);
  const [selectedLogisticPartyId, setSelectedLogisticPartyId] = useState('');
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [scpOptions, setScpOptions] = useState([]);
  const [selectedSCPName, setSelectedSCPName] = useState('');
  const [selectedSCPCode, setSelectedSCPCode] = useState('');
  const [shipmentCodes, setShipmentCodes] = useState([]);
  const [tableRecords, setTableRecords] = useState(() => {
    const storedData = sessionStorage.getItem('tableRecords');
    console.log('storedData', storedData);
    return storedData ? JSON.parse(storedData) : [];
  });
  const [scpCode, setScpCode] = useState('');
  const [selectedShipmentCode, setSelectedShipmentCode] = useState('');
  const [text, setText] = useState('');
  const [invalidQuantities, setInvalidQuantities] = useState([]);
  const [returnReasonOptions, setReturnReasonOptions] = useState([]);
  const [returnShipmentCode, setReturnShipmentCode] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalSelectedDate, setModalSelectedDate] = useState('');
  const [isSCPNameEmpty, setIsSCPNameEmpty] = useState(false);
  const [isShipmentCodeEmpty, setIsShipmentCodeEmpty] = useState(false);
  const [isReasonEmpty, setIsReasonEmpty] = useState(false);
  const [isLogisiticEmpty, setIsLogisticEmpty] = useState(false);
  const [confirmRemoveIndex, setConfirmRemoveIndex] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSelectOpen, setIsSelectOpen] = useState(null);

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  useEffect(() => {
    const fetchVehicleNumbers = async () => {
      try {
        if (selectedLogisticPartyId !== '') {
          setTimeout(async () => {
            const response = await fetch(`${config.API_URL}/logisticcompany/vehicles/${selectedLogisticPartyId}`);
            const data = await response.json();
            setVehicleOptions(data.vehicleData);
          }, 1000);
        }
      } catch (error) {
        console.error('Error fetching vehicle numbers:', error);
        setVehicleOptions([]);
      }
    };
    fetchVehicleNumbers();
  }, [selectedLogisticPartyId]);

  useEffect(() => {
    const fetchSCPName = async () => {
      try {
        const response = await fetch(`${config.API_URL}/api/scp/${selectedScpId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch SCP name');
        }
        const data = await response.json();
        setScpCode(data.scpName);
      } catch (error) {
        console.error('Error fetching SCP name:', error);
      }
    };
    if (selectedScpId) {
      fetchSCPName();
    }
  }, [selectedScpId]);

  useEffect(() => {
    const fetchCodes = async () => {
      await fetchShipmentCodes(selectedSCPCode, selectedScpId);
    };
    fetchCodes();
  }, [selectedScpId, selectedSCPCode]);

  useEffect(() => {
    const fetchLogisticPartyAndSCPOptions = async () => {
      if (selectedScpId) {
        await fetchLogisticParty(selectedScpId);
        await fetchSCPOptions(selectedScpId);
      }
      try {
        const response = await fetch(`${config.API_URL}/enumtype/returnreason`);
        const data = await response.json();
        setReturnReasonOptions(data);
      } catch (error) {
        console.error('Error fetching return reasons:', error);
      }
    };
    fetchLogisticPartyAndSCPOptions();
  }, [UM_CompanyID, selectedScpId]);

  useEffect(() => {
    sessionStorage.setItem('tableRecords', JSON.stringify(tableRecords));
  }, [tableRecords]);

  useEffect(() => {
    const storedLogisticParty = sessionStorage.getItem('selectedLogisticPartyId');
    const storedVehicleNumber = sessionStorage.getItem('vehicleNumber');
    const storedSCPName = sessionStorage.getItem('selectedSCPName');
    const storedReason = sessionStorage.getItem('returnReason');
    const storedText = sessionStorage.getItem('text');
    const storedDate = sessionStorage.getItem('shipmentDate');
    const storedSCPCode = sessionStorage.getItem('selectedSCPCode');
    const storedShipmentCode = sessionStorage.getItem('selectedShipmentCode');

    console.log('storedLogisticParty', storedLogisticParty);
    console.log('storedVehicleNumber', storedVehicleNumber);
    console.log('storedSCPName', storedSCPName);
    console.log('storedSCPCode', storedSCPCode);
    console.log('storedReason', storedReason);

    if (storedSCPName) setSelectedSCPName(storedSCPName);
    if (storedSCPCode) setSelectedSCPCode(storedSCPCode);
    if (storedLogisticParty) setSelectedLogisticPartyId(storedLogisticParty);
    if (storedVehicleNumber) setVehicleNumber(storedVehicleNumber);
    if (storedReason) setReturnReason(parseInt(storedReason));
    if (storedText) setText(storedText);
    if (storedDate) setShipmentDate(storedDate);
    if (storedShipmentCode) setSelectedShipmentCode(storedShipmentCode);
  }, []);

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "Shipment Return:", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const generateShipmentCode = async (scpName) => {
    try {
      const response = await fetch(`${config.API_URL}/api/return/shipmentcodegenerate/${scpName}`);
      if (!response.ok) throw new Error('Failed to generate shipment code');
      const data = await response.json();
      return data.shipmentCode;
    } catch (error) {
      console.error('Error generating shipment code:', error);
      return '';
    }
  };

  const fetchLogisticParty = (selectedScpId) => {
    fetch(`${config.API_URL}/shipment/logisticcompany/${selectedScpId}`)
      .then((response) => response.json())
      .then((data) => {
        setLogisticParty(data.logisticCompany);
        setVehicleOptions([]);
      })
      .catch((error) => {
        console.error('Error fetching logistic company data:', error);
      });
  };

  const fetchSCPOptions = (selectedScpId) => {
    fetch(`${config.API_URL}/shipmentmaster/scpcode/${selectedScpId}`)
      .then((response) => response.json())
      .then((data) => {
        setScpOptions(data.SCPNames);
      })
      .catch((error) => {
        console.error('Error fetching shipment options:', error);
      });
  };

  const fetchShipmentCodes = (selectedSCPName, selectedScpId) => {
    fetch(`${config.API_URL}/shipmentlist/shipmentcodes/${selectedScpId}/${selectedSCPName}`)
      .then((response) => response.json())
      .then((data) => {
        setShipmentCodes(data.shipmentCodes);
      })
      .catch((error) => {
        console.error('Error fetching shipment codes:', error);
      });
  };

  const handleLogisticPartyChange = async (selectedOption) => {
    const selectedPartyId = selectedOption ? selectedOption.value : '';
    setSelectedLogisticPartyId(selectedPartyId);
    sessionStorage.setItem('selectedLogisticPartyId', selectedPartyId);
    try {
      const response = await fetch(`${config.API_URL}/logisticcompany/vehicles/${selectedPartyId}`);
      if (!response.ok) throw new Error('Failed to fetch vehicle numbers');
      const data = await response.json();
      setVehicleOptions(data.vehicleData);
    } catch (error) {
      console.error('Error fetching vehicle numbers:', error);
      setVehicleOptions([]);
    }
  };

  const handleSCPChange = (selectedOption) => {
    const selectedSCP = scpOptions.find((scp) => scp.SCPM_Name === selectedOption?.value);
    if (selectedSCP) {
      setSelectedSCPName(selectedSCP.SCPM_Name);
      setIsSCPNameEmpty(false);
      fetchShipmentCodes(selectedSCP.SHPD_SCPCode, selectedScpId);
      sessionStorage.setItem('selectedSCPName', selectedSCP.SCPM_Name);
      sessionStorage.setItem('selectedSCPCode', selectedSCP.SHPD_SCPCode);
    } else {
      setSelectedSCPName('');
      setShipmentCodes([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (returnReason === '' || selectedLogisticPartyId === '') {
      if (returnReason === '') setIsReasonEmpty(true);
      else setIsReasonEmpty(false);
      if (selectedLogisticPartyId === '') setIsLogisticEmpty(true);
      else setIsLogisticEmpty(false);
      return;
    } else {
      setIsReasonEmpty(false);
      setIsLogisticEmpty(false);
    }

    if (tableRecords.length <= 0) {
      toast.error('You need to add at least one shipment to save return shipment.');
      return;
    }

    for (const item of tableRecords) {
      if (item.ReturnQuantity === '' || parseInt(item.ReturnQuantity) <= 0) {
        toast.error(`Please Enter Return Quantity for Product: ${item.ProductName} (Product Code: ${item.ProductCode}).`);
        return;
      }
    }

    const generatedShipmentCode = await generateShipmentCode(scpCode);
    setReturnShipmentCode(generatedShipmentCode);
    const sumReturnQuantitiesByProductCode = tableRecords.reduce((acc, record) => {
      if (!acc[record.ProductCode]) acc[record.ProductCode] = 0;
      acc[record.ProductCode] += Number(record.ReturnQuantity);
      return acc;
    }, {});

    try {
      const updatePromises = Object.entries(sumReturnQuantitiesByProductCode).map(async ([productCode, blockQty]) => {
        const response = await fetch(`${config.API_URL}/inventory/updateBlockQty`, {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ blockQty, scpid: selectedScpId, productCode }),
        });
        if (!response.ok) throw new Error(`Failed to update block quantity for Product Code: ${productCode}`);
        const responseData = await response.json();
        console.log(`Block quantity updated successfully for Product Code: ${productCode}:`, responseData);
      });
      await Promise.all(updatePromises);
    } catch (error) {
      console.error('Error updating block quantities:', error);
      toast.error('Failed to update block quantities.');
      return;
    }

    try {
      const updateResponse = await fetch(`${config.API_URL}/shipmentmaster/update-return-qty`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          records: tableRecords.map((record) => ({
            shipmentMID: record.ShipmentMID,
            returnQuantity: record.ReturnQuantity,
          })),
        }),
      });
      if (!updateResponse.ok) throw new Error('Failed to update return quantities');
      const updateData = await updateResponse.json();
      console.log('Return quantities updated successfully:', updateData);

      const data = {
        shipmentType: 'Return',
        returnShipmentCode: generatedShipmentCode,
        shipmentDate,
        logisticPartyId: selectedLogisticPartyId,
        vehicleNumber: vehicleNumber || null,
        returnReason,
        text,
        selectedScpId,
        UM_CompanyGrpID,
        UM_CompanyID,
        UM_UserId,
        records: tableRecords.map((record) => ({
          scpCode: record.SCPCode,
          shipmentCode: record.ShipmentCode,
          productCode: record.ProductCode,
          productName: record.ProductName,
          receivedQuantity: record.ReceivedQuantity,
          returnQuantity: record.ReturnQuantity,
        })),
      };
      const response = await fetch(`${config.API_URL}/api/shipmentreturn`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error('Failed to submit data');
      const responseData = await response.json();
      console.log('Data saved successfully:', responseData);
      setLoading(true);
      toast.success(`Return Shipment : Ret_${generatedShipmentCode} saved successfully.`, {
        onClose: () => {
          handleReset();
          setLoading(false);
        },
      });

      try {
        const notificationResponse = await fetch(`${config.API_URL}/notificationmaster/save`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            NFM_EventType: 'Shipment Creation',
            NFM_EventBy: UM_UserId,
            NFM_Status: 0,
            NFM_EventMessage: `Return Shipment with Shipment code: 'Ret_${generatedShipmentCode}' is created successfully`,
            NFM_CompanyID: UM_CompanyID,
            NFM_CompanyGrpID: UM_CompanyGrpID,
            NFM_SCPID: selectedScpId,
          }),
        });
        if (!notificationResponse.ok) throw new Error('Failed to save notification');
      } catch (notificationError) {
        console.error('Error saving notification:', notificationError);
        toast.error('Some problem occurred while saving the notification.');
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      toast.error('Sorry for inconvenience, Failed to create return shipment.');
    }
  };

  const handleShipmentCodeChange = (selectedOption) => {
    const selectedCode = selectedOption ? selectedOption.value : '';
    setSelectedShipmentCode(selectedCode);
    setIsShipmentCodeEmpty(false);
    sessionStorage.setItem('selectedShipmentCode', selectedCode);
  };

  const handleChange = (e) => {
    const text = e.target.value;
    setText(text);
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
    sessionStorage.setItem('text', text);
  };

  const handleAddAllToTable = async () => {
    try {
      if (selectedSCPName === '') {
        setIsSCPNameEmpty(true);
        return;
      } else {
        setIsSCPNameEmpty(false);
      }
      if (shipmentCodes.length === 0) {
        toast.error('No shipment codes available for the selected SCP.');
        return;
      }

      let allCodesAlreadyExist = true;
      for (const code of shipmentCodes) {
        if (!tableRecords.some((record) => record.ShipmentCode === code)) {
          allCodesAlreadyExist = false;
          break;
        }
      }

      if (allCodesAlreadyExist) {
        toast.error('All shipment codes are already present in the table.');
        return;
      }

      for (const code of shipmentCodes) {
        const selectedSCP = scpOptions.find((scp) => scp.SCPM_Name === selectedSCPName);
        if (!selectedSCP) throw new Error('Selected SCP not found');
        const response = await fetch(`${config.API_URL}/shipmentmaster/details/${code}`);
        if (!response.ok) throw new Error(`Failed to fetch shipment details for code ${code}`);
        const data = await response.json();
        const { shipmentDetails } = data;
        const existingRecords = tableRecords.filter((record) => record.ShipmentCode === code);
        const recordsToAdd = shipmentDetails.filter(
          (detail) => !existingRecords.some((record) => record.ShipmentMID === detail.SHPD_ShipmentMID)
        );

        recordsToAdd.forEach((detail) => {
          setTableRecords((prevRecords) => [
            ...prevRecords,
            {
              SCPCode: selectedSCP.SHPD_SCPCode,
              SCPName: selectedSCPName,
              ShipmentMID: detail.SHPD_ShipmentMID,
              ShipmentCode: code,
              ProductName: detail.SHPD_ProductName,
              ProductCode: detail.SHPD_ProductCode,
              ReceivedQuantity: detail.SHPD_ReceivedQty,
              RemainingQuantity: detail.RemainingQty,
              originalRemainingQty: detail.RemainingQty,
              ReturnQuantity: '',
            },
          ]);
        });
      }
    } catch (error) {
      console.error('Error adding all records to table:', error);
      toast.error(`Error adding all records to table: ${error.message}`);
    }
  };

  const handleAddToTable = async () => {
    try {
      if (selectedSCPName === '') setIsSCPNameEmpty(true);
      else setIsSCPNameEmpty(false);
      if (selectedShipmentCode === '') setIsShipmentCodeEmpty(true);
      else setIsShipmentCodeEmpty(false);
      if (selectedSCPName === '' || selectedShipmentCode === '') return;

      const selectedSCP = scpOptions.find((scp) => scp.SCPM_Name === selectedSCPName);
      if (!selectedSCP) throw new Error('Selected SCP not found');

      const response = await fetch(`${config.API_URL}/shipmentmaster/details/${selectedShipmentCode}`);
      if (!response.ok) throw new Error('Failed to fetch shipment details');
      const data = await response.json();
      const { shipmentDetails } = data;

      const existingRecords = tableRecords.filter((record) => record.ShipmentCode === selectedShipmentCode);
      const recordsToAdd = shipmentDetails.filter(
        (detail) => !existingRecords.some((record) => record.ShipmentMID === detail.SHPD_ShipmentMID)
      );

      if (recordsToAdd.length === 0) {
        toast.error(`All records for Shipment Code ${selectedShipmentCode} already exist in the table.`);
        return;
      }

      recordsToAdd.forEach((detail) => {
        setTableRecords((prevRecords) => [
          ...prevRecords,
          {
            SCPCode: selectedSCP.SHPD_SCPCode,
            SCPName: selectedSCPName,
            ShipmentMID: detail.SHPD_ShipmentMID,
            ShipmentCode: selectedShipmentCode,
            ProductName: detail.SHPD_ProductName,
            ProductCode: detail.SHPD_ProductCode,
            ReceivedQuantity: detail.SHPD_ReceivedQty,
            RemainingQuantity: detail.RemainingQty,
            originalRemainingQty: detail.RemainingQty,
            ReturnQuantity: '',
          },
        ]);
      });
    } catch (error) {
      console.error('Error adding record to table:', error);
      toast.error(`Error adding record to table: ${error.message}`);
    }
  };

  const handleReset = () => {
    setReturnReason('');
    setSelectedLogisticPartyId('');
    setVehicleNumber('');
    setSelectedSCPName('');
    setSelectedShipmentCode('');
    setText('');
    setInvalidQuantities([]);
    setIsReasonEmpty(false);
    setIsLogisticEmpty(false);
    setIsSCPNameEmpty(false);
    setIsShipmentCodeEmpty(false);
    setTableRecords([]);
    sessionStorage.removeItem('selectedLogisticPartyId');
    sessionStorage.removeItem('returnReason');
    sessionStorage.removeItem('shipmentDate');
    sessionStorage.removeItem('vehicleNumber');
    sessionStorage.removeItem('text');
    sessionStorage.removeItem('selectedSCPName');
    sessionStorage.removeItem('selectedSCPCode');
    sessionStorage.removeItem('selectedShipmentCode');
    sessionStorage.removeItem('tableRecords');
    window.location.reload();
  };

  const handleReturnReason = (selectedOption) => {
    const returnReason = selectedOption ? selectedOption.value : '';
    setReturnReason(returnReason);
    sessionStorage.setItem('returnReason', returnReason);
  };

  const handleVehicle = (selectedOption) => {
    const vehicle = selectedOption ? selectedOption.value : '';
    setVehicleNumber(vehicle);
    sessionStorage.setItem('vehicleNumber', vehicle);
  };

  const shipmentCodeOptions = shipmentCodes.map((code) => ({
    value: code,
    label: code,
  }));

  const returnReasonOptionsFormatted = returnReasonOptions.map((option) => ({
    value: option.enumVal,
    label: option.description,
  }));

  const logisticPartyOptions = logisticParty.map((party) => ({
    value: party.LGCM_ID,
    label: party.LGCM_Name,
  }));

  const vehicleOptionsFormatted = vehicleOptions.map((vehicle) => ({
    value: vehicle.LGCVM_ID,
    label: vehicle.LGCVM_VehicleNumber,
  }));

  const scpOptionsFormatted = scpOptions.map((scp) => ({
    value: scp.SCPM_Name,
    label: scp.SCPM_Name,
  }));

  const handleReturnQuantityChange = (e, index) => {
    let returnQty = parseInt(e.target.value);
    const updatedRecords = [...tableRecords];

    if (e.target.value === '') returnQty = 0;
    if (returnQty < 0) return;

    if (returnQty >= 0 && returnQty <= updatedRecords[index].originalRemainingQty) {
      updatedRecords[index].ReturnQuantity = returnQty;
      updatedRecords[index].RemainingQuantity = updatedRecords[index].originalRemainingQty - returnQty;
    } else {
      toast.error(`Quantity cannot exceed the remaining quantity of ${updatedRecords[index].originalRemainingQty}.`);
    }
    setTableRecords(updatedRecords);
  };

  const handleDateChange = (date) => {
    console.log('handleDateChange(): Started');
    setModalSelectedDate(date);
    setShowModal(true);
    console.log(`handleDateChange(): Date changed to ${date ? format(date, 'dd-MM-yyyy') : 'null'}`);
    console.log('handleDateChange(): Ended');
  };

  const handleModalCancel = () => {
    setShowModal(false);
  };

  const handleModalConfirm = () => {
    setShipmentDate(modalSelectedDate);
    sessionStorage.setItem('shipmentDate', modalSelectedDate);
    setShowModal(false);
  };

  const handleConfirmRemove = (index) => {
    setConfirmRemoveIndex(index);
    setShowConfirmModal(true);
  };

  const handleCancelRemove = () => {
    setConfirmRemoveIndex(null);
    setShowConfirmModal(false);
  };

  const handleRemoveRecord = () => {
    const updatedRecords = [...tableRecords];
    updatedRecords.splice(confirmRemoveIndex, 1);
    setTableRecords(updatedRecords);
    setConfirmRemoveIndex(null);
    setShowConfirmModal(false);
  };

  return (
    <>
      <ToastContainer
        style={{
          marginTop: '73px',
          fontSize: '14px',
          width: '40%',
        }}
      />
      {loading && (
        <div
          style={{
            position: 'fixed',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: 1000,
          }}
        />
      )}
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="main_container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="formHeading">Shipment Return</h1>
              <div className="row">
                <div className="col-md-4 mb-1">
                  <label className="form-label">Shipment Type</label>
                  <input
                    type="text"
                    id="shipmentType"
                    name="shipmentType"
                    value="Return"
                    disabled
                    className="form-input"
                    style={{
                      backgroundColor: '#f2f2f2',
                      color: '#6c757d',
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="returnReason">
                    Return Reason<span style={{ color: 'red' }}>{isReasonEmpty ? ' *' : ''}</span>
                  </label>
                  <div className="select-container">
                    <Select
                      className="routing_select-box"
                      options={returnReasonOptionsFormatted}
                      value={returnReasonOptionsFormatted.find((opt) => opt.value === returnReason) || null}
                      onChange={handleReturnReason}
                      placeholder="--Select--"
                      onMenuOpen={() => handleSelectOpen('returnReason')}
                      onMenuClose={handleSelectClose}
                    />
                    <div className="icon-container_list myList">
                      <i>{isSelectOpen === 'returnReason' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="shipmentDate">Shipment Date</label>
                  <DatePicker
                    selected={shipmentDate}
                    onChange={handleDateChange}
                    dateFormat="dd-MM-yyyy"
                    onKeyDown={(e) => e.preventDefault()}
                  />
                  {/* <Modal backdrop="static" show={showModal} onHide={handleModalCancel} centered>
                    <Modal.Header>
                      <Modal.Title
                        style={{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          color: '#465a64',
                          margin: 'auto',
                        }}
                      >
                        :: User Confirmation ::
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body
                      style={{
                        fontSize: '18px',
                        fontWeight: '500',
                        color: '#465a64',
                        margin: 'auto',
                      }}
                    >
                      Are you sure you want to change the date?
                    </Modal.Body>
                    <div className="popup_btn_container">
                      <button className="yes_btn" onClick={handleModalConfirm}>
                        YES
                      </button>
                      <button className="no_btn" onClick={handleModalCancel}>
                        NO
                      </button>
                    </div>
                  </Modal> */}
                  {showModal && (
                    <div className="popup_overlay">
                      <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4>Are you sure you want to change the date ?</h4>
                        <div className="popup_btn_container">
                          <button className="yes_btn " onClick={handleModalConfirm}>
                            YES
                          </button>
                          <button className="no_btn " onClick={handleModalCancel}>
                            NO
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-4 mt-2">
                  <label className="form-label">
                    Logistic Party Name<span style={{ color: 'red' }}>{isLogisiticEmpty ? ' *' : ''}</span>
                  </label>
                  <div className="select-container">
                    <Select
                      className="routing_select-box"
                      options={logisticPartyOptions}
                      value={logisticPartyOptions.find((opt) => opt.value === parseInt(selectedLogisticPartyId)) || null}
                      onChange={handleLogisticPartyChange}
                      placeholder="--Select--"
                      onMenuOpen={() => handleSelectOpen('logisticParty')}
                      onMenuClose={handleSelectClose}
                    />
                    <div className="icon-container_list myList">
                      <i>{isSelectOpen === 'logisticParty' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mt-2 row">
                  <div className="col-md-11">
                    <label className="form-label">Vehicle Number</label>
                    <div className="select-container">
                      <Select
                        className="routing_select-box"
                        options={vehicleOptionsFormatted}
                        value={vehicleOptionsFormatted.find((opt) => opt.value === parseInt(vehicleNumber)) || null}
                        onChange={handleVehicle}
                        placeholder="--Select--"
                        onMenuOpen={() => handleSelectOpen('vehicleNumber')}
                        onMenuClose={handleSelectClose}
                      />
                      <div className="icon-container_list myList">
                        <i>{isSelectOpen === 'vehicleNumber' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <Link to={`/dashboard/lgcm`}>
                      <img
                        title="Create Vehicle"
                        src={add}
                        alt="Add All Icon"
                        style={{
                          width: '19px',
                          height: '19px',
                          marginTop: '41px',
                        }}
                      />
                    </Link>
                  </div>
                </div>
                <div className="ms-4 col-md-4 mt-2">
                  <label className="form-label">Shipment Status</label>
                  <input
                    type="text"
                    style={{
                      backgroundColor: '#f2f2f2',
                      color: '#6c757d',
                    }}
                    value="Created"
                    className="form-input"
                    disabled
                  />
                </div>
                <div className="col-md-4 mt-2">
                  <label htmlFor="shipment">
                    SCP Name<span style={{ color: 'red' }}>{isSCPNameEmpty ? ' *' : ''}</span>
                  </label>
                  <div className="select-container">
                    <Select
                      className="routing_select-box"
                      options={scpOptionsFormatted}
                      value={scpOptionsFormatted.find((opt) => opt.value === selectedSCPName) || null}
                      onChange={handleSCPChange}
                      placeholder="--Select--"
                      onMenuOpen={() => handleSelectOpen('scpName')}
                      onMenuClose={handleSelectClose}
                      isDisabled={tableRecords.length > 0}
                    />
                    <div className="icon-container_list myList">
                      <i>{isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 row mt-2">
                  <div className="col-md-11">
                    <label htmlFor="shipmentCode">
                      Shipment Code<span style={{ color: 'red' }}>{isShipmentCodeEmpty && ' *'}</span>
                    </label>
                    <div className="select-container">
                      <Select
                        className="routing_select-box"
                        options={shipmentCodeOptions}
                        value={shipmentCodeOptions.find((opt) => opt.value === selectedShipmentCode) || null}
                        onChange={handleShipmentCodeChange}
                        placeholder="--Select--"
                        onMenuOpen={() => handleSelectOpen('shipmentCode')}
                        onMenuClose={handleSelectClose}
                      />
                      <div className="icon-container_list myList">
                        <i>{isSelectOpen === 'shipmentCode' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}</i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1">
                    <img
                      title="Add All"
                      src={add}
                      alt="Add All Icon"
                      onClick={handleAddAllToTable}
                      style={{
                        width: '19px',
                        height: '19px',
                        marginTop: '41px',
                      }}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <label htmlFor="returnComment">Return Comment</label>
                    <textarea
                      id="returnComment"
                      name="returnComment"
                      value={text}
                      onChange={handleChange}
                      rows="3"
                      style={{
                        border: '1px solid rgb(206, 212, 218)',
                        padding: '10px',
                        width: '100%',
                        resize: 'none',
                        overflow: 'auto',
                        transition: 'height 0.3s ease 0s',
                        borderRadius: '5px',
                        maxHeight: '100px',
                        height: '230px',
                        color: '#465a64',
                        fontSize: '14px',
                        fontWeight: '500',
                        outline: 'none',
                      }}
                      placeholder="Enter Return Comment"
                    />
                  </div>
                  <div className="col-md-8">
                    <button type="button" className="shipment_add_btn" onClick={handleAddToTable}>
                      ADD
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="table_div mt-3">
            {tableRecords.length > 0 && (
              <table className="tableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>SCP Name</th>
                    <th>Shipment Code</th>
                    <th>Product Name</th>
                    <th>Product Code</th>
                    <th>Received Quantity</th>
                    <th>Remaining Quantity</th>
                    <th>Return Quantity</th>
                    <th>Action</th>
                    <th style={{ display: 'none' }}>SCP Code</th>
                  </tr>
                </thead>
                <tbody>
                  {tableRecords.map((record, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{record.SCPName}</td>
                      <td>{record.ShipmentCode}</td>
                      <td>{record.ProductName}</td>
                      <td>{record.ProductCode}</td>
                      <td>{record.ReceivedQuantity}</td>
                      <td>{record.RemainingQuantity}</td>
                      <td>
                        <input
                          type="number"
                          className="form-input"
                          value={record.ReturnQuantity === 0 ? '' : record.ReturnQuantity}
                          onChange={(e) => handleReturnQuantityChange(e, index)}
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={(e) => {
                            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                            if (allowedKeys.includes(e.key)) return;
                            if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                          }}
                        />
                        {invalidQuantities.includes(index) && (
                          <span style={{ color: 'red', fontSize: '0.8rem' }}>Invalid return quantity</span>
                        )}
                      </td>
                      <td>
                        <img
                          src={Icon5}
                          onClick={() => handleConfirmRemove(index)}
                          className="suspendicon"
                          alt="suspend"
                          title="Remove"
                        />
                      </td>
                      <td style={{ display: 'none' }}>{record.SCPCode}</td>
                      <td style={{ display: 'none' }}>{record.ShipmentMID}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {/* <Modal backdrop="static" show={showConfirmModal} onHide={handleCancelRemove} centered>
              <Modal.Header>
                <Modal.Title
                  style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#465a64',
                    margin: 'auto',
                  }}
                >
                  :: User Confirmation ::
                </Modal.Title>
              </Modal.Header>
              <Modal.Body
                style={{
                  fontSize: '18px',
                  fontWeight: '500',
                  color: '#465a64',
                  margin: 'auto',
                }}
              >
                Are you sure you want to remove this record?
              </Modal.Body>
              <div className="popup_btn_container">
                <button className="yes_btn" onClick={handleRemoveRecord}>
                  YES
                </button>
                <button className="no_btn" onClick={handleCancelRemove}>
                  NO
                </button>
              </div>
            </Modal> */}
            {showConfirmModal && (
              <div className="popup_overlay">
                <div className="resetpopup">
                  <h1>:: User Confirmation ::</h1>
                  <h4>Are you sure you want to remove this row ?</h4>
                  <div className="popup_btn_container">
                    <button className="yes_btn " onClick={handleRemoveRecord}>
                      YES
                    </button>
                    <button className="no_btn " onClick={handleCancelRemove}>
                      NO
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="button-container">
          <button className="save_btn" type="submit" onClick={handleSubmit}>
            SAVE
          </button>
          <button type="button" onClick={handleReset} className="reset_btn">
            RESET
          </button>
          <Link to={`/shipmentreturnlist`} className="list_btn" type="button">
            LIST
          </Link>
        </div>
      </form>
    </>
  );
}

export default ShipmentReturn;